import { createFileRoute, redirect } from '@tanstack/react-router';
export const Route = createFileRoute('/_staff/person/alumni/$id/_profile/')({
  beforeLoad: ({
    params
  }) => {
    const {
      id
    } = params;
    throw redirect({
      to: '/person/alumni/$id/personal-information',
      params: {
        id
      }
    });
  }
});